import { TablePaginationConfig } from "antd/lib/table/interface";

export const PRIMARY_BUTTON_STYLE = "text-white bg-primary-500 border-primary-500 hover:bg-opacity-80 border-opacity-80 disabled:bg-opacity-70 disabled:border-opacity-70";
export const TABLE_PAGINATION_STYLE: TablePaginationConfig = { className: "mr-5", hideOnSinglePage: false, defaultPageSize: 25, showQuickJumper: true, showSizeChanger: false };
